/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { PostProcessingStatusEnum } from "./PostProcessingStatusEnum";
import {
  PostProcessingStatusEnumFromJSON,
  PostProcessingStatusEnumFromJSONTyped,
  PostProcessingStatusEnumToJSON,
  PostProcessingStatusEnumToJSONTyped,
} from "./PostProcessingStatusEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PostProcessingStatus
 */
export interface PostProcessingStatus {
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  status: PostProcessingStatusEnum;
  /**
   *
   */
  readonly created?: Date;
}

/**
 * Check if a given object implements the PostProcessingStatus interface.
 */
export function instanceOfPostProcessingStatus(value: object): value is PostProcessingStatus {
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function PostProcessingStatusFromJSON(json: any): PostProcessingStatus {
  return PostProcessingStatusFromJSONTyped(json, false);
}

export function PostProcessingStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostProcessingStatus {
  if (json == null) {
    return json;
  }
  return {
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    status: PostProcessingStatusEnumFromJSON(json["status"]),
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
  };
}

export function PostProcessingStatusToJSON(json: any): PostProcessingStatus {
  return PostProcessingStatusToJSONTyped(json, false);
}

export function PostProcessingStatusToJSONTyped(
  value?: Omit<PostProcessingStatus, "simulation" | "created"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    status: PostProcessingStatusEnumToJSON(value["status"]),
  };
}
